import React, { useState } from 'react';
import { Link } from "react-router-dom"; // Added for sidebar links


const ProcedureQuickCodes = () => {
  // Data array matching the table in the image
  const procedureData = [
    { quickCode: 'POA', procedure: '1-7 ALIGNERS (SINGLE ARCH)' },
    { quickCode: '3D MOD', procedure: '3D PRINTED STUDY MODELS' },
    { quickCode: 'TJ', procedure: 'ABUTMENT TRANSFER JIG' },
    { quickCode: 'ATA', procedure: 'ALIGNER TEMPLATE WITH ATTACHMENTS' },
    { quickCode: 'CCB', procedure: 'ALL ON 4 COBALT CHROME BAR WITH ACRYLIC TEETH' },
    { quickCode: 'AC', procedure: 'ANGLE CORRECTION' },
    { quickCode: 'CR', procedure: 'CEMENT RETAINED CROWN' },
    { quickCode: 'CC', procedure: 'CLINCHECK' },
    { quickCode: 'DSW', procedure: 'DIGITAL SMILE DESIGN/DIAGNOSTIC' },
    { quickCode: 'BTP', procedure: 'DIGITAL-BLEACHING TRAY' },
    { quickCode: 'GOLS', procedure: 'DUAL LAMINATE SPLINT' },
    { quickCode: 'EB', procedure: 'EMAX BRIDGE' },
    { quickCode: 'EC', procedure: 'EMAX CROWN' },
    { quickCode: 'EV', procedure: 'EMAX VENEER' },
    { quickCode: 'EVO', procedure: 'EVO BITE' },
    { quickCode: 'PS', procedure: 'EXPRESS SERVICE 1-2 DAYS' },
    { quickCode: 'FR-TJ', procedure: 'FIXED RETAINER WITH TRANSFER JIG' },
    { quickCode: 'IMDSD', procedure: 'FULLARCH TEMPORARY-DIGITAL WORKFLOW' },
    { quickCode: 'FGS1', procedure: 'FULLY GUIDED SURGICAL STENT (SMOP x 1 IMPLANT)' },
    { quickCode: 'FGS2', procedure: 'FULLY GUIDED SURGICAL STENT (SMOP x 2 IMPLANTS)' },
    { quickCode: 'FGS3', procedure: 'FULLY GUIDED SURGICAL STENT (SMOP x 3 IMPLANTS)' },
  ];
  // Hover state manage karne ke liye
  const [hoveredIndex, setHoveredIndex] = useState(null);
  return (
    <>
  
      <div style={{ width: "1900px", margin: "0 auto", padding: "0px" }}>
        <div className="row">
    
          <div className="col-md-10">
            <h1>Procedure Quick Codes</h1>
            <h2 style={{ color: "#004aad", marginBottom: '10px' }}>Details</h2>
            <div style={{
              borderRadius: '4px',
              overflow: 'hidden',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}>
              <div style={{
                backgroundColor: '#f4f4f4',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                borderTop: '2px solid #004aad',
                fontWeight: 'bold',
                fontSize: '16px',
                height: '60px',
              }}>
                <div style={{ flex: '0 0 150px', marginRight: '20px' }}>Quick Code</div>
                <div style={{ flex: '1' }}>Procedure</div>
              </div>
              {procedureData.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '4px 10px',
                    borderBottom: index < procedureData.length - 1 ? '1px solid #f4f4f4' : 'none',
                    backgroundColor: hoveredIndex === index ? '#f4f4f4' : 'transparent',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease'
                  }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <div style={{ flex: '0 0 150px', marginRight: '20px', fontWeight: '500' }}>
                    {item.quickCode}
                  </div>
                  <div style={{ flex: '1' }}>
                    {item.procedure}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
   
    </>
  );
};

export default ProcedureQuickCodes;